
import React from 'react';
import { motion } from 'framer-motion';

const PartnerBenefits = () => {
  const benefits = [
    {
      benefit: "New Revenue Stream",
      meaning: "Add $15K–$30K/month from your same patient base"
    },
    {
      benefit: "No Overhead",
      meaning: "We staff, supply, and operate the medspa wing"
    },
    {
      benefit: "Better Retention",
      meaning: "Keep patients coming back with smile + skin bundles"
    },
    {
      benefit: "Practice Equity",
      meaning: "Increase your valuation with recurring cash flow"
    }
  ];

  return (
    <section className="py-32 bg-juv-cream-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-serif font-light text-juv-deep-chestnut mb-6">
            What You Get as a Partner
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl shadow-luxury overflow-hidden"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 bg-juv-deep-chestnut text-white p-6">
            <div className="font-semibold text-xl">Benefit</div>
            <div className="font-semibold text-xl">What It Means for You</div>
          </div>
          
          {benefits.map((item, index) => (
            <div key={index} className={`grid grid-cols-1 md:grid-cols-2 p-6 border-b border-gray-100 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
              <div className="font-semibold text-juv-deep-chestnut text-lg mb-2 md:mb-0">{item.benefit}</div>
              <div className="text-juv-deep-chestnut/80 leading-relaxed">{item.meaning}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerBenefits;
